import React, { useState } from 'react'
import { Layout, Menu, Avatar, Dropdown, Button, Badge } from 'antd'
import { useNavigate, useLocation, Outlet } from 'react-router-dom'
import {
  DashboardOutlined, ProjectOutlined, BankOutlined,
  ArrowUpOutlined, ArrowDownOutlined, BarChartOutlined,
  SettingOutlined, UserOutlined, LogoutOutlined, TagsOutlined,
  SwapOutlined, TeamOutlined, MenuFoldOutlined, MenuUnfoldOutlined
} from '@ant-design/icons'
import useStore from '../store'

const { Sider, Content } = Layout

const menuItems = [
  { key: '/', icon: <DashboardOutlined />, label: '总览' },
  { type: 'divider' },
  { key: '/projects', icon: <ProjectOutlined />, label: '项目管理' },
  { key: '/accounts', icon: <BankOutlined />, label: '账户管理' },
  { key: '/income', icon: <ArrowUpOutlined />, label: '收入管理' },
  { key: '/expenses', icon: <ArrowDownOutlined />, label: '支出管理' },
  { key: '/reports', icon: <BarChartOutlined />, label: '报表' },
  { type: 'divider' },
  { key: '/categories', icon: <TagsOutlined />, label: '类别管理' },
  { key: '/exchange-rates', icon: <SwapOutlined />, label: '汇率管理' },
  { key: '/owners', icon: <TeamOutlined />, label: '负责人管理' },
  { key: '/users', icon: <SettingOutlined />, label: '用户管理' },
]

// SVG Logo
function KingRoadLogo({ collapsed }) {
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '18px 12px',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      marginBottom: 8,
      cursor: 'default',
      userSelect: 'none',
      background: '#111',
    }}>
      {collapsed ? (
        <span style={{
          fontFamily: "'Inter', 'Arial Black', sans-serif",
          fontWeight: 900, fontSize: 16, letterSpacing: 2,
          color: '#fff',
        }}>K<span style={{ color: '#c8922a' }}>R</span></span>
      ) : (
        <span style={{
          fontFamily: "'Inter', 'Arial Black', sans-serif",
          fontWeight: 900, fontSize: 18, letterSpacing: 4,
          textTransform: 'uppercase',
        }}>
          <span style={{ color: '#fff' }}>KING</span>
          <span style={{ color: '#c8922a' }}>ROAD</span>
        </span>
      )}
    </div>
  )
}

export default function AppLayout() {
  const [collapsed, setCollapsed] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout } = useStore()

  const userMenu = {
    items: [{ key: 'logout', icon: <LogoutOutlined />, label: '退出登录' }],
    onClick: ({ key }) => { if (key === 'logout') { logout(); navigate('/login') } }
  }

  const visibleMenuItems = (user?.role === 'admin' ? menuItems : menuItems.filter(m => m.key !== '/users'))

  const roleColor = { admin: '#f50', finance: '#1677ff', readonly: '#52c41a' }
  const roleLabel = { admin: '管理员', finance: '财务', readonly: '只读' }

  return (
    <Layout style={{ minHeight: '100vh', background: '#f5f6fa' }}>
      <Sider
        collapsible collapsed={collapsed} onCollapse={setCollapsed}
        width={210}
        trigger={null}
        style={{ position: 'fixed', height: '100vh', left: 0, top: 0, zIndex: 100 }}
      >
        <KingRoadLogo collapsed={collapsed} />
        <Menu
          theme="dark" mode="inline"
          selectedKeys={[location.pathname]}
          items={visibleMenuItems}
          onClick={({ key }) => navigate(key)}
          style={{ border: 'none', padding: '0 0 80px 0' }}
        />
      </Sider>

      <Layout style={{ marginLeft: collapsed ? 80 : 210, transition: 'margin-left 0.2s' }}>
        {/* Custom Header */}
        <div className="app-header">
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            style={{ fontSize: 16, color: '#374151' }}
          />
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <Badge color={roleColor[user?.role]} text={<span style={{ fontSize: 12, color: '#6b7280' }}>{roleLabel[user?.role]}</span>} />
            <Dropdown menu={userMenu} placement="bottomRight">
              <Button type="text" style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 8px', borderRadius: 8 }}>
                <Avatar size={28} style={{ background: 'linear-gradient(135deg, #1677ff, #4096ff)', fontSize: 12 }}>
                  {user?.name?.[0]}
                </Avatar>
                <span style={{ fontWeight: 500, color: '#374151' }}>{user?.name}</span>
              </Button>
            </Dropdown>
          </div>
        </div>

        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
